import type { FaireProductEntity } from "../../entity_types/product";

export const p_cd9kc3jbk4: FaireProductEntity = {
  token: "p_cd9kc3jbk4",
  type: "product",
  name: "Goose Cake Hat Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/76d50651bfca2ee3ed0f70ce256866b345e480a39ae59cf0096333948924144c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/440cf1552ae8e60a6cc0c158f311bb8620025c3e0a3b849c54829ea6dca0a969.jpeg",
    "https://cdn.faire.com/fastly/d61936a0372cdfc07b5c0d2d7f9ae48191329f742177a6a97f2d150fde64bb63.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:20.564Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
